import { getCustomerPlan } from 'src/data/subscription';

import { useCurrentCustomer } from '.';

export const useCurrentCustomerPlan = () => {
  const currentCustomer = useCurrentCustomer();

  return getCustomerPlan(currentCustomer);
};
